import { render, staticRenderFns } from "./DiscontinuedProduction.vue?vue&type=template&id=46199259&"
import script from "./DiscontinuedProduction.vue?vue&type=script&lang=js&"
export * from "./DiscontinuedProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports